module.exports = __webpack_public_path__ + "img/please-wait.802b0a34.svg";